import ConsultaError from "../consultaError/consultaError.vue"

export default {
	name: "consulta-list",
	props: ["propConsultas", "propAreas", "loadPaginate"],
	components: {
		ConsultaError
	},
	data() {
		return {
			attrLoader: {
				class: 'ma-6',
				boilerplate: false,

			},
			loadingCards: true,
			headers: [{
					text: "Data Criação",
					value: "created_at"
				},
				{
					text: "Atualizado em",
					value: "updated_at"
				},
				{
					text: "Título",
					value: "titulo"
				}
			],
			abrirCardConsulta: false,
			strFiltro: "",
			defaultSelectedOrderBy: "",
			itemsPerPage: 10,
			descending: true,
			valid: true,
			registro: {
				_id: 0,
				strNome: ""
			},
			arOptions: [-1],
			timeoutPesquisa: true,
			arItensOrderBy: [{
					name: 'Tema',
					value: 'tema'
				}, {
					name: 'Titulo',
					value: 'titulo'
				}, {
					name: 'UF',
					value: 'uf'
				},
				{
					name: 'Atendente',
					value: 'atendente'
				},
				{
					name: 'Situação',
					value: 'situacao'
				}
			],
			defaultSelectedArea: "",
			arItensArea: [{
				name: 'Trabalhista',
				value: 'Trabalhista'
			}, {
				name: 'Federal',
				value: 'Federal'
			}, {
				name: 'Fiscal',
				value: 'Fiscal'
			}],
			strTema: [{
					id: "1",
					strDescricao: "1"
				},
				{
					id: "2",
					strDescricao: "2"
				}
			],
			selectTema: '',
			helpTema: false

		}
	},
	mounted() {

	},
	updated() {

	},
	watch: {

	},
	created() {
		console.log(this.$root.$store.state.idAreaLista);
		if(this.$root.$store.state.idAreaLista != "") {
			this.updateArea();
		}
	},
	computed: {

		totalPages: function() {
			var total = this.propConsultas.totalConsultas
			var totalDiv = this.propConsultas.totalConsultas / 10
			var totalInt = (parseInt(totalDiv))

			return totalDiv >= totalInt ? totalInt + 1 : totalInt

		},
		checkNext: function() {
			var totalConsultas = this.propConsultas.totalConsultas
			var paginaAtual = this.$root.$store.state.paginaAtual



			if (totalConsultas < 10 || (paginaAtual * 10) >= totalConsultas) {

				return true
			} else {
				return false
			}
		},
		existFilter: function() {
			if (this.strFiltro !== "" || this.defaultSelectedArea != "" || this.defaultSelectedOrderBy != "" || this.$root.$store.state.idAreaLista !== "" || this.$root.$store.state.idTema !== "" || this.$root.$store.state.pesquisaPalavra !== "")
				return true;
			return false;
		},


		/* 		filtered: function() {
				
					let tmpRegistros = [];

					if (this.strFiltro == "" || this.strFiltro == null || this.strFiltro == undefined) {
						tmpRegistros = this.propConsultas.consultas;
					} else {
						tmpRegistros = this.propConsultas.consultas.filter(e => {

							if (

								e.strAssunto
								.toLowerCase()
								.indexOf(this.strFiltro.toLowerCase()) > -1
							) {
								return true;
							}
						});
					}
					//filtro por area
					if (this.defaultSelectedArea.length > 0) {
						tmpRegistros = tmpRegistros.filter(e => {

							if (
								e.strNomeArea
								.toLowerCase()
								.indexOf(this.defaultSelectedArea.toLowerCase()) > -1
							) {
								return true;
							}
						});
					}

					let arSort = tmpRegistros.sort((a, b) => {
						const sortA = a[this.defaultSelectedOrderBy];
						const sortB = b[this.defaultSelectedOrderBy];

						if (this.descending) {
							if (sortA < sortB) return 1;
							if (sortA > sortB) return -1;
							return 0;
						} else {
							if (sortA < sortB) return -1;
							if (sortA > sortB) return 1;
							return 0;
						}
					});

					console.log('sort:',arSort)
					console.log('registros:', this.propConsultas.consultas)
					return arSort;
				} */
	},
	methods: {
		consultaExpirada(data) {
			var dataConsulta = new Date(data)
			var hoje = new Date()
			const diferencaTempo = Math.abs(hoje - dataConsulta);
			const differencaDias = Math.ceil(diferencaTempo / (1000 * 60 * 60 * 24))

			return differencaDias >= 30
		},
		updateArea() {

			this.$root.$store.state.idTema = ''
			this.$root.$api.listarTemasPorIdArea(this.$root.$store.state.token, this.$root.$store.state.idAreaLista).then(response => {
				this.strTema = response
			})
		},
		updateTema() {
			this.$root.$store.state.idTema
		},

		mudarPágina(direcao) {
			if (direcao === '+') {
				this.$root.$store.state.paginaAtual++

			} else {
				this.$root.$store.state.paginaAtual--
			}
		},

		clearFilter() {
			/**
			 * Limpando os stores
			 */
			this.$root.$store.state.pesquisaPalavra = ''
			this.$root.$store.state.idAreaLista = ''
			this.$root.$store.state.ordenarPor = ''
			this.$root.$store.state.idTema = ''

		},

		customSort(items, index, isDesc) {
			items.sort((a, b) => {
				if (index === "date") {
					if (!isDesc) {
						return compare(a.date, b.date);
					} else {
						return compare(b.date, a.date);
					}
				}
			});
			return items;
		},
		getClass(p_prioridade) {
			switch (p_prioridade) {
				case 'baixa':
					return 'i-green';
				case 'media':
					return 'i-yelow';
				case 'alta':
					return 'i-red';
				default:
					return 'i-green';
			}
		},

		checkTema() {
			if (this.$root.$store.state.idAreaLista === '') {
				this.helpTema = true

				setTimeout(() => {
					this.helpTema = false
				}, 10000);
			} else {
				return
			}
		}
	}
}